import { onFieldValidated } from '../actions/actions.validation';
import EventBus from '../services/service.eventBus';
import { fetchZipCode } from '../services/service.zipCode';
import { state as answerState, onChange as onAnswerChange } from '../store/store.answers';
import { state as customerState } from '../store/store.customer';
import { state as validationState } from '../store/store.validation';
import { getReplacementVehicleProperties } from '../utils/utils.answers';
import { QUESTION_CAPTCHA_RESULT, QUESTION_LEAD_TYPE, QUESTION_LOOKING_FOR, QUESTION_MAKE_MODEL, QUESTION_YEAR_RANGE } from '../utils/utils.question';
import { BROWSER_STORAGE_TTL, STORAGE_TYPE, writeStoreToBrowserStorage } from '../utils/utils.store';

export const onContactFormInit = () => {
  // Run validation on init using any answers loaded from session storage
  validateContactForm(true);

  onAnswerChange('contactInfo', () => validateContactForm());
  onAnswerChange('replacementVehicle', () => validateContactForm());
};

export const onValidateZipCode = async (zipCode: string): Promise<void> => {
  try {
    EventBus.publish('onValidateZipCode', { zipCode });
    const isValid = await onValidateZipCodeSuccess(zipCode);
    onFieldValidated('contactInfo', 'zip', isValid);
    if (isValid) {
      writeStoreToBrowserStorage({ ManualZipCode: true }, 'ManualZipCode', BROWSER_STORAGE_TTL.TTLNoExpired, STORAGE_TYPE.LOCAL);
      writeStoreToBrowserStorage({ ZipCode: zipCode }, 'ZipCode', BROWSER_STORAGE_TTL.TTLNoExpired, STORAGE_TYPE.LOCAL);
    }
  } catch (error) {
    onValidateZipCodeFail(error);
    onFieldValidated('contactInfo', 'zip', true);
  }
  validateContactForm(true);
};

const onValidateZipCodeSuccess = async (zipCode: string): Promise<boolean> => {
  const data = await fetchZipCode(zipCode);
  const isValid = data.isKnownZipCode;
  EventBus.publish('onValidateZipCodeSuccess', isValid);
  return isValid;
};

const onValidateZipCodeFail = (error) => {
  EventBus.publish('onValidateZipCodeFail', error);
};

const validateContactForm = (strobe = false) => {
  const ci = answerState.contactInfo;
  const captchaResult = answerState.captcha;
  const errors = new Set<string>();

  const {
    replacementIsLookingForReplacementVehicle,
    replacementIsLookingForNewCars,
    replacementIsLookingForCertifiedCars,
    replacementIsLookingForUsedCars,
    replacementMinYear,
    replacementMaxYear,
    isValidMakeModelId,
  } = getReplacementVehicleProperties(answerState.replacementVehicle);

  if (!captchaResult.response && captchaResult.captchaReady) {
    errors.add(QUESTION_CAPTCHA_RESULT);
  }
  if (!ci.legalAcceptance && customerState.showLegalAcceptance) {
    validationState.fields.contactInfo.add('legalAcceptance');
  }
  if (customerState && customerState.showReplacementVehicleSection) {
    if (replacementIsLookingForReplacementVehicle !== true && replacementIsLookingForReplacementVehicle !== false) {
      errors.add(QUESTION_LEAD_TYPE);
    }
    if (replacementIsLookingForReplacementVehicle && !replacementIsLookingForNewCars && !replacementIsLookingForCertifiedCars && !replacementIsLookingForUsedCars) {
      errors.add(QUESTION_LOOKING_FOR);
    }

    const hasYearRange = !!(replacementMinYear && replacementMaxYear);

    if (replacementIsLookingForReplacementVehicle && !hasYearRange) {
      errors.add(QUESTION_YEAR_RANGE);
    }

    if (replacementIsLookingForReplacementVehicle && !isValidMakeModelId) {
      errors.add(QUESTION_MAKE_MODEL);
    }
  }

  validationState.form = {
    ...validationState.form,
    contactInfo: errors,
  };

  const oldIsValid = validationState.result.contactInfo;
  const newIsValid = !errors.size && !validationState.fields.contactInfo.size;

  validationState.result.contactInfo = newIsValid;

  if (strobe || newIsValid !== oldIsValid) {
    EventBus.publish('FormValidated', { form: 'customer-contact', isValid: newIsValid });
  }
};

export const onValidateConsent = (isValid: boolean = false) => {
  EventBus.publish('FormValidated', { form: 'customer-contact', isValid });
};
